import React from 'react';
import LegalDoc from '../components/LegalDoc';

const PrivacyPolicyPage: React.FC = () => {
  return <LegalDoc title="Политика конфиденциальности" fileUrl="/legal/policy.md" />;
};

export default PrivacyPolicyPage;
